

























































































import { Component, Prop, Vue } from "vue-property-decorator";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

// import CustomInput from '@/commonComponents/customInput/customInput.vue';

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    ValueEdit,
    ColorSelector,
    AdjustedBalloon,
    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})
export default class PolygonTransform extends Vue {
  @Prop()
  private layer!: PolygonLayer;

  //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
  //こいつはpropsでもらいたい
  openStatus = {
    opend: true
  };

  polygonTransformContentsOpenAnimate = false;
  polygonTransformContentsCloseAnimate = false;

  open() {
    if (this.openStatus.opend) {
      this.polygonTransformContentsCloseAnimate = true;
      setTimeout(() => {
        this.polygonTransformContentsCloseAnimate = false;
        this.polygonTransformContentsOpenAnimate = false;
        this.openStatus.opend = false;
      }, 200);
    } else {
      this.openStatus.opend = true;
      this.polygonTransformContentsOpenAnimate = true;
      setTimeout(() => {
        this.polygonTransformContentsOpenAnimate = false;
      }, 250);
    }
  }
  //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

  //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
  //こいつはpropsでいらない
  isColorPickerVisible = false;
  showColorPicker() {
    this.isColorPickerVisible = true;
  }
  closeColorPicker() {
    this.isColorPickerVisible = false;
  }
  //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

  //↓↓↓↓↓チェックボックスのアニメーション↓↓↓↓↓
  private get ratioFixed() {
    return this.layer.keepRatio == 0;
  }

  ratioFixChange() {
    // 縦横固定だった場合、内部データは縦固定にする。ただしこのアプリ内では自由変形
    // *スマホアプリとのデータ共存のため
    var newValue = this.layer.keepRatio == 0 ? 1 : 0;
    this.changeLayerProperty("keepRatio", newValue);
  }

  private get noStroke() {
    return this.layer.noStroke;
  }

  switchNoStroke() {
    let newValue = !this.layer.noStroke;
    this.changeLayerProperty("noStroke", newValue);
  }

  //↑↑↑↑↑チェックボックスのアニメーション↑↑↑↑↑

  //↓↓↓↓↓色↓↓↓↓↓
 

  get strokeColor() : ColorConstruct{
    return this.layer.strokeColor;
  }

  get strokeColorStyle() {
    return {
      background: this.strokeColor.hex
    };
  }

  // 色変更中
  private onChangingColor(color)
  {
    this.changeLayerProperty("strokeColor" , color);
  }
    // 色変更完了
  private onChangedColor(color)
  {
    this.changeLayerProperty("strokeColor" , color);
  }

  //↑↑↑↑↑色↑↑↑↑↑

  //*** 線幅 ***//
  private get strokeWidth(): string {
    return this.fixStrokeWidth(this.layer.strokeWidth).toFixed(2);
  }

  private setStrokeWidth(value: number) {
    // 値の補正
    var fixedValue = this.fixStrokeWidth(value);
    if (this.layer.strokeWidth != fixedValue) {
      // 値変更
      this.changeLayerProperty("strokeWidth", fixedValue);
    } else {
      // 表示のみ更新
      var input = this.$refs.strokeWidth as HTMLInputElement;
      input.value = this.strokeWidth;
    }
  }

  private increaseStrokeWidth(delta: number) {
    // 値の補正
    var fixedValue = this.fixStrokeWidth(this.layer.strokeWidth, delta);
    if (this.layer.strokeWidth != fixedValue) {
      // 値変更
      this.changeLayerProperty("strokeWidth", fixedValue);
    }
  }

  private fixStrokeWidth(value: number, delta: number = 0): number {
    var fixed;
    if (delta > 0) {
      // X.X0 に補正
      fixed = Math.floor(value * 10) / 10 + delta;
    } else if (delta < 0) {
      // X.X0 に補正
      fixed = Math.ceil(value * 10) / 10 + delta;
    } else {
      // X.XX に補正
      fixed = Math.round(value * 100) / 100;
    }

    // 0 ~ 10mm
    if (fixed < 0) {
      fixed = 0;
    }
    if (fixed > 10) {
      fixed = 10;
    }
    return fixed;
  }

  //*** 丸み ***//
  private get radius(): string {
    return this.fixRadius(this.layer.radius).toFixed(0);
  }

  private setRadius(value: number) {
    // 値の補正
    var fixedValue = this.fixRadius(value);
    if (this.layer.radius != fixedValue) {
      // 値変更
      this.changeLayerProperty("radius", fixedValue);
    } else {
      // 表示のみ更新
      var input = this.$refs.radius as HTMLInputElement;
      input.value = this.radius;
    }
  }

  private increaseRadius(delta: number) {
    // 値の補正
    var fixedValue = this.fixRadius(
      this.layer.radius,
      delta
    );
    if (this.layer.radius != fixedValue) {
      // 値変更
      this.changeLayerProperty("radius", fixedValue);
    }
  }

  private fixRadius(value: number, delta: number = 0): number {
    // X に補正
    var fixed = Math.round(value) + delta;
    // 0 ~ 100 %
    if (fixed < 0) {
      fixed = 0;
    }
    if (fixed > 100) {
      fixed = 100;
    }
    return fixed;
  }

  private changeLayerProperty(propertyName: string, value: any) {
    this.$emit("doCommand", "changeLayerProperty", {
      layer: this.layer,
      propertyName: propertyName,
      value: value
    });
  }

  changeMode(){
    this.$emit("doCommand", "changeEditMode", { mode : 1 });
  }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
